import React from "react";
import { useSelector } from "react-redux";
import { Typography, Divider } from "@material-ui/core";

import ReadyToGoTabs from "./components/ReadyToGoTabs/ReadyToGoTabs";
import { readyToGoTabs, TABS } from "./config/tabs";
import GeneralPage from "./pages/GeneralPage/GeneralPage";
import LateCollectionPage from "./pages/LateCollectionPage/LateCollectionPage";
import UnderReviewPage from "./pages/UnderReviewPage/UnderReviewPage";
import ThreeDaysStuckPage from "./pages/ThreeDaysStuckPage/ThreeDaysStuckPage";
import useStyles from "./ReadyToGo.styles";

export default function ReadyToGo(props) {
  const classes = useStyles();
  const [activeTab, setActiveTab] = React.useState(TABS.GERAL);

  const counts = useSelector(
    (state) => (state.orders.grids["ready-to-go"] || {}).counts
  );

  const tabs = readyToGoTabs.map((tab) =>
    tab.countKey && counts && counts[tab.countKey] != null
      ? { ...tab, count: counts[tab.countKey] }
      : tab
  );

  const renderPage = () => {
    switch (activeTab) {
      case TABS.GERAL:
        return <GeneralPage {...props} />;
      case TABS.COLETA_TARDIA:
        return <LateCollectionPage {...props} />;
      case TABS.EM_ANALISE:
        return <UnderReviewPage {...props} />;
      case TABS.TRES_DIAS_PARADO:
        return <ThreeDaysStuckPage {...props} />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className={classes.header}>
        <Typography variant="h5">Pronto para retirada</Typography>
        <Typography variant="subtitle1">
          Aguardando o entregador para coleta do pedido.
        </Typography>
      </div>

      <Divider variant="middle" className={classes.divider} />

      <ReadyToGoTabs tabs={tabs} value={activeTab} onChange={setActiveTab} />

      {renderPage()}
    </>
  );
}
